import { Flex, Text } from "@gravity-ui/uikit";

import { ProductPriceSummary as PriceSummary } from "../../../../utils";
import { useProductPriceSummaryTranslate } from "./hooks";

interface ProductPriceSummaryProps {
  summary: PriceSummary | null;
}

export const ProductPriceSummary = ({ summary }: ProductPriceSummaryProps) => {
  const translations = useProductPriceSummaryTranslate();

  if (!summary) return null;

  return (
    <Flex direction="column">
      <Text variant="header-1">
        {translations.from_price(summary.minPrice, summary.currency)}
      </Text>
      <Text variant="body-2" color="secondary">
        {translations.offers_on_stores(
          summary.offersCount,
          summary.storesCount,
        )}
      </Text>
    </Flex>
  );
};
